export enum LeadPreferredLanguage {
  Arabic = 'ar',
  English = 'en',
  Spanish = 'es',
}

export enum LeadInsurancePlanType {
  Empty = '',
  Unknown = 'unknown',
  EPO = 'epo',
  HMO = 'hmo',
  POS = 'pos',
  PPO = 'ppo',
}

export enum LeadSystemSource {
  PartnerReferral = 'partner-referral',
  CommunityReferral = 'community-referral',
  MaintainPartnerReferral = 'maintain-partner-referral',
}

export enum Source {
  PartnerReferral = 'partner-referral',
}

export enum LeadGender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
}
export type LeadBase = {
  agentEmail?: string;
  bmi?: number;
  city?: string;
  clinicId?: number;
  email: string;
  feet?: number;
  firstName: string;
  gender?: LeadGender;
  groupNumber?: string;
  inches?: number;
  insuranceId?: string;
  insurancePlanType?: LeadInsurancePlanType;
  lastName: string;
  otherInsurance?: string;
  payer?: string;
  phone?: string;
  preferredLanguage?: LeadPreferredLanguage;
  referredBy?: string;
  source?: LeadSystemSource | string;
  state?: string;
  street?: string;
  systemSource?: LeadSystemSource;
  weight: number;
  zipCode?: string;
  dateOfBirth?: string;
  metadata?: {
    secondaryInsurance?: {
      insurancePlanType?: string;
      insuranceName?: string;
      groupNumber?: number;
      insuranceId?: number | null;
      otherInsuranceName?: string;
    };
  };
};

export type LeadAndProvider = {
  meta?: {
    systemSource?: LeadSystemSource;
    isCommunityReferral?: boolean;
    communityReferralClinicName?: string;
  };
  patient: LeadBase;
  agent?: {
    email: string;
  };
};

export enum FlowConfigOption {
  Disabled = 'disabled',
  Enabled = 'enabled',
}
export interface FlowConfig {
  d2c?: FlowConfigOption;
  referrals?: FlowConfigOption;
}

export type ClinicReferringDoctor = {
  id: number;
  name: string;
  aliases: string[];
};

export type ClinicConfig = {
  id: number;
  name: string;
  address: string;
  slug: string;
  state: string;
  logo: string;
  zipCode: string;
  status: string;
  flowConfig?: FlowConfig;
  referringDoctors: ClinicReferringDoctor[];
};
